import { ITestPurchaseMethod } from 'APIPackage/CatalogsModule/interfaces/ITestPurchaseMethod';

export const createTestPurchaseMethodSelectOption = (testPurchaseMethod: ITestPurchaseMethod) => ({
  ...testPurchaseMethod,
  label: testPurchaseMethod.name,
  value: testPurchaseMethod.code,
});
